import { RouterProvider } from 'react-router-dom';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { HaloProvider } from '@prenuvo/halo';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/core/react-query';
import { ReportIssueProvider } from '@/core/report-issue';
import { SessionCheck } from '@/core/session-check';
import { UserState } from '@/core/user';

import { LOCALES } from './i18n';
import { ROUTES } from './routes';

export function App() {
  return (
    <OpenFeatureProvider>
      <HaloProvider language="en" locales={LOCALES}>
        <QueryClientProvider client={queryClient}>
          <SessionCheck />

          <UserState>
            <ReportIssueProvider>
              <RouterProvider future={{ v7_startTransition: true }} router={ROUTES} />
            </ReportIssueProvider>
          </UserState>
        </QueryClientProvider>
      </HaloProvider>
    </OpenFeatureProvider>
  );
}
